import React from "react"
import "./styles.scss"
import { Modal } from "react-bootstrap"
import PropTypes from "prop-types"
import { useGlobalState } from "../../global/global"
import { getLanguageFile } from "../../global/langauge.helper"

const ClarificaitonModal = ({ onHide, showModal }) => {
  const [state] = useGlobalState()
  return (
    <Modal
      show={showModal}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <h4 className="modal-title">
          {getLanguageFile(state.language).ClarificationText.headerOne}
        </h4>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphOne}
        </p>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphTwo}
        </p>
        <h4 className="modal-sub-title">
          {getLanguageFile(state.language).ClarificationText.headerTwo}
        </h4>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphTree}
        </p>
        <ul>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemOne}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemTwo}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemThree}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemFour}
            </p>
          </li>
        </ul>

        <h4 className="modal-sub-title">
          {getLanguageFile(state.language).ClarificationText.headerThree}
        </h4>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphFour}
        </p>
        <h4 className="modal-sub-title">
          {getLanguageFile(state.language).ClarificationText.headerFour}
        </h4>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphFive}
        </p>

        <ul>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemFive}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemSix}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemSeven}
            </p>
          </li>
          <li>
            <p className="description bullet">
              {getLanguageFile(state.language).ClarificationText.listItemEight}
            </p>
          </li>
        </ul>

        <h4 className="modal-sub-title">
          {getLanguageFile(state.language).ClarificationText.headerFive}
        </h4>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphSix}
        </p>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphSeven}
        </p>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphEight}
        </p>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphNine}
        </p>
        <p className="description">
          {getLanguageFile(state.language).ClarificationText.paragraphTen}
          <br />
          {getLanguageFile(state.language).ClarificationText.paragraphEleven}
          <br />
          {getLanguageFile(state.language).ClarificationText.paragraphTwelve}
        </p>
      </Modal.Body>
    </Modal>
  )
}

ClarificaitonModal.propTypes = {
  showModal: PropTypes.boolean,
  onHide: PropTypes.any,
}

ClarificaitonModal.defaultProps = {
  showModal: false,
}

export default ClarificaitonModal
